import React, { FC } from 'react';

const IconChat: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" {...props}>
      <polygon
        fillRule="evenodd"
        points="5.833 7.5 10.325 12.5 15 7.5"
        transform="translate(-5 -7)"
      />
    </svg>
  );
};

export default IconChat;
